import { Navigate, Routes, Route } from 'react-router-dom';
import BudgetBike from '../views/budgetBike/BudgetBike';
import MainView from '../views/main/MainView';
import InternationaleMap from '../views/map/InternationaleMap';
import SampleBike from '../views/sampleBike/SampleBike';

const Routing = () => {
    return (
        <Routes>
            <Route
                path='*'
                element={<Navigate to='/main' />}
            />
            <Route
                element={<MainView />}
                path='/main'
            />
            <Route
                element={<InternationaleMap />}
                path='/nl/map'
            />
            <Route
                element={<InternationaleMap />}
                path='/en/map'
            />
            <Route
                element={<InternationaleMap />}
                path='/fr/map'
            />
            <Route
                path='/nl/sample-bike/:budget'
                element={<SampleBike />}
            />
            <Route
                element={<SampleBike />}
                path='/nl/sample-bike/'
            />
            <Route
                element={<SampleBike />}
                path='/en/sample-bike'
            />
            <Route
                element={<SampleBike />}
                path='/en/sample-bike/:budget'
            />
            <Route
                element={<SampleBike />}
                path='/fr/sample-bike'
            />
            <Route
                element={<SampleBike />}
                path='/fr/sample-bike/:budget'
            />
            <Route
                element={<BudgetBike />}
                path='/nl/budget-bike'
            />
            <Route
                element={<BudgetBike />}
                path='/en/budget-bike'
            />
            <Route
                element={<BudgetBike />}
                path='/fr/budget-bike'
            />
        </Routes>
    );
}

export default Routing;
